import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  console.log(componentDefaultValue,'componentDefaultValue');
  componentDefaultValue[uie.source] = parameter;
  let searchParameter = { ...sectionComponent.state.searchParameter };
  console.log(searchParameter,'searchParameter');
  searchParameter[uie.source] = parameter;
  if (uie.source === 'ModuleId') {
    searchParameter['ModuleId'] = parameter;
  }
  sectionComponent.setState({ searchParameter, componentDefaultValue });

  let defaultFormData = { ...pageComponent.state.defaultFormData };
  console.log(defaultFormData,'defaultFormData');
  defaultFormData[uie.source] = parameter;
  if (uie.source === 'ModuleId') {
    defaultFormData['moduleId'] = parameter;
  }
  if (uie.source === 'ClientId') {
    defaultFormData['clientId'] = parameter;
  }
  pageComponent.setState({ defaultFormData, hasClientId: false });

  let filterLoaded = true;
  sectionComponent.state.section.componentList.filter(c => c.type === 'View')[0].topFilterList[0].uieList.map((uie, i) => {
    if (componentDefaultValue[uie.source] === undefined || componentDefaultValue[uie.source] === null) {
      filterLoaded = false;
    }
  })

  if (filterLoaded) {
    if (pageComponent.state.clientId !== null) {
      defaultFormData['clientId'] = parseInt(pageComponent.state.clientId);
      searchParameter['ClientId'] = parseInt(pageComponent.state.clientId);
      componentDefaultValue['ClientId'] = parseInt(pageComponent.state.clientId);
      sectionComponent.setState({ searchParameter, componentDefaultValue });
      pageComponent.setState({ defaultFormData });
    }
    if (pageComponent.state.moduleId !== null) {
      defaultFormData['moduleId'] = parseInt(pageComponent.state.moduleId);
      searchParameter['ModuleId'] = parseInt(pageComponent.state.moduleId);
      componentDefaultValue['ModuleId'] = parseInt(pageComponent.state.moduleId);
      sectionComponent.setState({ searchParameter, componentDefaultValue });
      pageComponent.setState({ defaultFormData });
    }

    setTimeout(() => {
      sectionComponent.getSectionDataByDefault();
      pageComponent.setState({ moduleId: null, clientId: null });
    }, config.setTimeoutMilliSecond);
  }
}

export function addBySection({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (!pageComponent.state.submitting) {
    pageComponent.setState({ submitting: true });
    let form = {};
    form.moduleId = pageComponent.state.defaultFormData.moduleId;
    form.clientId = pageComponent.state.defaultFormData.clientId;
    httpClient
      .post('/Admin/ClientJobTemplate', form)
      .then(({ data }) => {
        if (data.result) {
          pageComponent.setState({ submitting: false });
          pageComponent.props.history.push('/admin/client-job-template-detail/' + data.data.ClientJobTemplateId);
        } else {
          pageComponent.setState({ submitting: false });
          globalFunction.handleResultError(data, pageComponent);
        }
      }).catch(function (error) {
        pageComponent.setState({ submitting: false });
        globalFunction.handleError(error, pageComponent);
      });
  }
}

export function copyClientJobTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
 pageComponent.setState({ copyClientJobTemplateShow: true });
 pageComponent.getClientSelectOptionList();
}